/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */


(function ($) {

    /** Overlay Spy Plugin */

    var overlaySpyMethods = {
        opts: {},
        init: function (options) {
            var $this = this;
            overlaySpyMethods.opts = $.extend({}, $.fn.overlaySpy.defaults, options);

            $this.each(function () {
                var $obj = $(this);
                $obj.data('overlaySpy', {
                    targetTop: $(overlaySpyMethods.opts.target).offset().top,
                    itemToggle: false
                });
                $(window).bind('scroll.overlaySpy', {obj: $obj, execute: false}, overlaySpyMethods.checkPosition);
            });
            $(window).on('resize', function () {
                $this.each(function () {
                    var obj = $(this);
                    obj.data('overlaySpy').targetTop = $(overlaySpyMethods.opts.target).offset().top;
                    overlaySpyMethods.getPosition(obj);
                });
            });
        },

        getPosition: function (obj) {
            var $this = obj;
            var position = {
                itemTop: $this.offset().top,
                itemBottom: $this.offset().top + $this.height()
            };

            $this.data('overlaySpy', $.extend({}, $this.data('overlaySpy'), position));
        },

        checkPosition: function (e) {
            var $this = e.data.obj;
            overlaySpyMethods.getPosition($this);
            var data = $this.data('overlaySpy');
            if (data.targetTop <= ((overlaySpyMethods.opts.bottom) ? data.itemBottom : data.itemTop) && !data.itemToggle) {
                data.itemToggle = true;
                $this.toggleClass(overlaySpyMethods.opts.class);
            } else if (data.targetTop >= ((overlaySpyMethods.opts.bottom) ? data.itemBottom : data.itemTop) && data.itemToggle) {
                data.itemToggle = false;
                if ($this.hasClass(overlaySpyMethods.opts.class)) {
                    $this.removeClass(overlaySpyMethods.opts.class);
                }
            }
        }
    };

    $.fn.overlaySpy = function (method) {

        if (overlaySpyMethods[method]) {
            return overlaySpyMethods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return overlaySpyMethods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist on jQuery.globalMessage');
        }
    };

    $.fn.overlaySpy.defaults = {
        target: 'body',
        bottom: false,
        class: 'overlay'
    };

    $.fn.overlaySpy.opts = {};

    /** OverlaySpy END*/

    var Utilities = {
        $winSizeElem: $('[data-win-size]'),

        setSize: function () {
            var wWidth = $(window).width(),
                wHeight = $(window).height();
            if (this.$winSizeElem.length > 0) {
                this.$winSizeElem.each(function () {
                    var $this = $(this);
                    if ($this.data('win-size')) {
                        switch ($this.data('win-size')) {
                            case 'winWidth' :
                                $this.css('width', wWidth);
                                break;
                            case 'winHeight' :
                                $this.css('min-height', wHeight);
                                break;
                            case 'fullSize' :
                                $this.css({'width': wWidth, 'height': wHeight});
                                break;
                        }
                    }
                });
            }
        },

        updateEvents: function () {
            var that = this;

            $(window).on('resize', function () {
                that.setSize();
            });
        },
        initUtilities: function () {

            this.setSize();
            this.updateEvents();
        }
    };


    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages

                Utilities.initUtilities();

                $('.overlay-spy').overlaySpy({
                    target: 'footer.content-info',
                    class: 'negative'
                });

                var $header = $('header.top-bar'),
                    $footer = $('footer.content-info'),
                    currentScroll = 0; //Used to detect scroll up or down

                $(".open-mobile-button").on('click', function (e) {
                    e.preventDefault();
                    var hidden_menu = $(this).parent(".mobile-dropdown").find(".hidden-menu");
                    hidden_menu.slideToggle();
                    $(this).toggleClass("opened");
                });

                $(".buttons-container-mobile .hidden-menu a").on('click', function (e) {
                    e.preventDefault();
                    var hidden_menu = $(this).parent(".hidden-menu");
                    var opened_button = $(".open-mobile-button");
                    opened_button.toggleClass("opened");
                    hidden_menu.hide();
                });


                var sliderScrolled = false,
                    homepageSlider = $('.homepage-slider-container'),
                    fsSlider = $('.fs-slider-container');

                $(window).scroll(function () {
                    var nextScroll = ($(this).scrollTop() < 0) ? 0 : $(this).scrollTop(); // Mac Safari fix, avoid negative scrollTop()
                    var headerHeight = $header.height();
                    var headerBottom = nextScroll + headerHeight,
                        footerTop = $footer.offset().top;
                    var headerAbsTop = footerTop - headerHeight;

                    if (nextScroll > currentScroll) { //Scroll down condition
                        if ($header.hasClass('opaque')) {
                            $header.toggleClass('transparent opaque');
                        }
                        if ((homepageSlider.length > 0 || fsSlider.length > 0) && $(window).width() > 992) {
                            if ((nextScroll < homepageSlider.outerHeight() - 10 || nextScroll < fsSlider.outerHeight() - 10) && !sliderScrolled) {
                                sliderScrolled = true;
                                $('body, html').animate({scrollTop: homepageSlider.outerHeight() || fsSlider.outerHeight()}, 500, function () {
                                    sliderScrolled = false;
                                });
                            }
                        }
                    } else { // Scroll up
                        if ($header.hasClass('transparent')) {
                            $header.toggleClass('transparent opaque');
                        }
                    }
                    currentScroll = nextScroll;

                    if (headerBottom >= footerTop) {
                        var delta = (nextScroll - headerAbsTop) / headerHeight;
                        $header.css({'position': 'absolute', 'top': headerAbsTop});
                        $footer.find('.top-bar').css({'opacity': delta, filter: 'alpha(opacity=' + delta * 100 + ')'});
                        $('.wfl').css('background-color', '#ffffff');
                    } else {
                        $header.css({'position': '', 'top': ''});
                        $footer.find('.top-bar').css({'opacity': 0, filter: 'alpha(opacity=0)'});
                        $('.wfl').css('background-color', '#000000');
                    }
                });

                // Footer height fix

                $('#menu-footer-menu').children('li').matchHeight({
                    byRow: true
                });

                //single post slider
                $('#single-post-slider').owlCarousel({
                    loop: true,
                    items: 1,
                    dots: true,
                    autoplay: true,
                    autoplayTimeout: 5000,
                    animateOut: 'fadeOut'
                });

                var $fs_slider = $('#fs-slider');

                $fs_slider.owlCarousel({
                    loop: true,
                    nav: true,
                    autoplay: true,
                    autoplayTimeout: 7000,
                    items: 1,
                    dots: true,
                    dotsContainer: '#fs-slider-dots',
                    navText: ['<div class="nav-arrow"><i class="arrow-left-icon-negative"></i><span>PREV</span></div>', '<div class="nav-arrow"><i class="arrow-right-icon-negative"></i><span>NEXT</span></div>'],
                    animateOut: 'fadeOut'
                });

                function toggleNavVisibility() {
                    if ($fs_slider.length > 0) {
                        var $sideNavigation = $('.side-navigation');
                        if ($(window).outerWidth() >= 992 && $(window).scrollTop() < $(window).outerHeight()) {
                            $sideNavigation.css('visibility', 'hidden');
                        } else {
                            $sideNavigation.css('visibility', '');
                        }
                    }
                }

                toggleNavVisibility();

                // Window Events

                $(window).on('scroll', toggleNavVisibility);

                //script for opening modal on click
                $('#news-list').on('click', '.open-modal-button', function (event) {
                    event.preventDefault();
                    var $this = $(this);
                    var parent_of_button = $this.parents(".news-item-modal");
                    var modal_image_container = parent_of_button.children(".modal-image");
                    var modal_image_src = parent_of_button.attr("data-news-img");
                    modal_image_container.modal('show');
                    var modal_image_body = parent_of_button.find(".modal-body");

                    modal_image_container.on('shown.bs.modal', function () {
                        var image_modal = parent_of_button.find('.modal-body img').length;
                        if (!image_modal) {
                            modal_image_body.append('<img src="' + modal_image_src + '" />');
                        }
                    });
                });

                //script for opening modal on click on media page
                $('#media-container-masonry').on('click', '.open-modal-button', function (event) {
                    event.preventDefault();
                    var $this = $(this);
                    var parent_of_button = $this.parents(".media-item");
                    var modal_media_container = parent_of_button.children(".modal-media");
                    var modal_image_src = parent_of_button.attr("data-media-img");
                    var modal_video_src = parent_of_button.attr("data-media-video");
                    modal_media_container.modal('show');
                    var modal_image_body = parent_of_button.find(".modal-body");
                    modal_media_container.on('shown.bs.modal', function () {
                        if (modal_image_src) {
                            var image_modal = parent_of_button.find('.modal-body img').length;
                            if (!image_modal) {
                                modal_image_body.append('<img src="' + modal_image_src + '" />');
                            }
                        }
                        if (modal_video_src) {
                            var video_modal = parent_of_button.find('.modal-body-video');
                            if (video_modal.length > 0) {
                                video_modal.html(modal_video_src);
                            }
                        }
                    });
                });

                //script for opening modal on click on story page
                $('.timeline-container').on('click', '.open-modal-button', function (event) {
                    event.preventDefault();
                    var $this = $(this),
                        parent_of_button = $this.parents(".video-block"),
                        modal_media_container = $(".modal-story"),
                        modal_video_src = parent_of_button.attr("data-media-video"),
                        modal_video_text = parent_of_button.find($(".media-video-text")).text()
                    ;

                    modal_media_container.modal('show');
                    modal_media_container.on('shown.bs.modal', function () {
                        if (modal_video_src) {
                            var video_modal = modal_media_container.find('.modal-body-video');
                            if (video_modal.length > 0) {
                                video_modal.html(modal_video_src);
                            }
                        }
                        var modal_title = $(".modal-story-text");
                        modal_title.empty().text(modal_video_text);
                    });
                });

                var modal_media_video = $(".modal-media");
                modal_media_video.on('hidden.bs.modal', function () {
                    modal_media_video.find('.modal-body-video iframe').remove();
                });

                //match height on news items
                if ($(".news-block .news-item").length) {
                    $(".news-block .news-item").matchHeight();
                }

                // Megamenu desktop functions

                var $mainMenuContainer = $('#mainNav'),
                    $overlay = $('#megamenu-overlay'),
                    $mobileOverlay = $('#mobile-menu-overlay'),
                    gutterXl = 180,
                    gutterLg = 100,
                    breakpointXl = 1680,
                    breakpointLg = 1200,
                    breakpointMd = 992,
                    columnWidth = 0;

                var megamenuToggle = $mainMenuContainer.find('[data-toggle=megamenu-toggle]');

                var backIcon = '<i class="arrow-left-icon"></i>',
                    goToIcon = '<i class="arrow-right-icon"></i>',
                    closeIcon = '<i class="close-icon"></i>';

                var isMobile = ($(window).width() < breakpointMd);


                function calculateListHeight(list) {
                    var height = 0;

                    list.find('>li').each(function () {
                        height = height + $(this).height();
                    });

                    height = (height < 312) ? 312 : height;

                    return height;
                }

                function setListsHeight() {

                    $mainMenuContainer.find('li.item-level-0').each(function () {
                        var maxHeight = 0,
                            $this = $(this);

                        $this.find('ul').each(function () {
                            maxHeight = (maxHeight > calculateListHeight($(this))) ? maxHeight : calculateListHeight($(this));
                        });
                        if (isMobile) {
                            $this.find('.megamenu, div.first-column, ul.sub-menu-level-0, ul.sub-menu-level-1, div.last-column, .megamenu-image').css('height', '');
                            $this.find('.megamenu').css('min-height', $(window).height() - 95);
                            $this.find('ul.sub-menu-level-0, ul.sub-menu-level-1').css('min-height', $(window).height() - 145);
                        } else {
                            $this.find('.megamenu, ul.sub-menu-level-0, ul.sub-menu-level-1').css('min-height', '');
                            //$this.find('.megamenu, div.first-column, ul.sub-menu-level-0, ul.sub-menu-level-1, div.last-column, .megamenu-image').css('height', maxHeight );
                            $this.find('.megamenu, div.first-column, ul.sub-menu-level-0, ul.sub-menu-level-1, .megamenu-image').css('height', maxHeight + 50);
                        }


                    });
                }

                function setListsWidth(gutter, columns, imgCols) {
                    if (isMobile) {
                        columnWidth = $(window).width() * 65 / 100;
                        $('.megamenu, .mobile-back-button').css({'width': columnWidth, 'right': -columnWidth});
                    } else {
                        $('.megamenu').css({'width': '', 'right': ''});
                        columnWidth = ($(window).width() - (gutter * 2)) / columns;
                    }
                    $mainMenuContainer.find('li.item-level-0').each(function () {
                        var $this = $(this);
                        //$this.find('div.first-column, ul.sub-menu-level-0, ul.sub-menu-level-1, div.last-column').css('width', columnWidth);
                        $this.find('div.first-column, ul.sub-menu-level-0, ul.sub-menu-level-1').css('width', columnWidth);
                        $this.find('.megamenu-image').css('width', columnWidth * imgCols + gutter);
                    });
                }

                function setPositions(gutter) {
                    if (!isMobile) {
                        $('ul.sub-menu-level-0').css('margin-left', columnWidth);
                        $('ul.sub-menu-level-1').css('left', columnWidth);
                        //$('div.last-column').css('left', 2 * columnWidth + gutter );
                        $('div.last-column').css('margin-left', columnWidth);
                    }
                }

                function openSubMenu(item) {
                    var $goToLink = $('.go-to-link');

                    if (isMobile) {
                        item.find('ul.sub-menu-level-1').fadeIn(5).animate({left: 0}, 400);
                        $('.back-link').fadeIn(400).addClass('submenu-open').html($goToLink.data('parent').label + backIcon);
                    } else {
                        item.find('ul.sub-menu-level-1').fadeIn();
                        $('.back-link').addClass('submenu-open').html(backIcon + 'Back');
                    }

                    $goToLink.attr({href: item.find('> a').attr('href')}).html(item.find('> a').text() + goToIcon);
                    item.parent('ul.sub-menu').addClass('sub-menu-open');
                }

                function closeSubMenu() {
                    var $goToLink = $('.go-to-link');

                    if (isMobile) {
                        $('ul.sub-menu-level-1').animate({left: columnWidth}, 400).fadeOut();
                        $('.back-link').removeClass('submenu-open').html(backIcon + 'Back');
                    } else {
                        $('.back-link').removeClass('submenu-open').html(closeIcon + 'Close');
                        $('ul.sub-menu-level-1').fadeOut();
                    }
                    $goToLink.attr({href: $goToLink.data('parent').url}).html($goToLink.data('parent').label + goToIcon);
                    $('ul.sub-menu-open').removeClass('sub-menu-open');

                }

                function openMegamenu(item) {
                    $('.go-to-link').attr({href: item.attr('href')}).html(item.text() + goToIcon).data('parent', {
                        'label': item.text(),
                        'url': item.attr('href')
                    });

                    if (isMobile) {
                        item.parent().find('.megamenu').css('display', 'block').animate({right: 0}, 400).addClass('open');
                        $('.back-link').fadeIn(400).addClass('megamenu-open').html(backIcon + 'Back');
                    } else {
                        item.parent().find('.megamenu').slideDown(400);
                        item.parent().find('.megamenu-image').slideDown(600, function () {
                            $(this).animate({opacity: 1}, 400);
                        });
                        item.addClass('active');
                        $('.back-link').fadeIn().removeClass('submenu-open, megamenu-open').html(closeIcon + 'Close');
                        $overlay.css('visibility', 'visible').animate({opacity: 0.8}, 600);
                    }
                }

                function closeMegamenu(item, last) {
                    if (isMobile) {
                        $('.megamenu.open').animate({right: -columnWidth}, 400).removeClass('open');
                        $('.back-link').removeClass('megamenu-open').fadeOut(400);
                    } else {
                        item.parent().find('.megamenu-image').animate({opacity: 0}, 400, function () {
                            $(this).parent().find('.megamenu').slideUp(600);
                            $(this).slideUp(600);
                        });
                        item.removeClass('active');
                        closeSubMenu();
                        if (last) {
                            $overlay.animate({opacity: 0}, 600, function () {
                                $(this).css('visibility', 'hidden');
                            });
                        }
                    }
                }

                $mainMenuContainer.find('.back-link').click(function () {
                    if ($(this).hasClass('submenu-open')) {
                        closeSubMenu();
                    } else {
                        closeMegamenu(megamenuToggle, true);
                    }
                });

                $mainMenuContainer.find('ul.sub-menu-level-0 li.menu-item-has-children > a').click(function (evt) {
                    evt.preventDefault();
                    openSubMenu($(this).parent('li'));
                });

                // Menu desktop events and initMenu

                megamenuToggle.each(function () {
                    var $this = $(this);
                    var $other = megamenuToggle.not($this);
                    $this.click(function (evt) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        if ($other.is('.active')) {
                            $other.removeClass('active');
                            $other.each(function () {
                                closeMegamenu($(this));
                            });
                        }
                        if ($this.is('.active')) {
                            closeMegamenu($this, true);
                            return false;
                        }
                        openMegamenu($this);
                    });
                });

                $overlay.click(function () {
                    megamenuToggle.each(function () {
                        if ($(this).hasClass('active')) {
                            $(this).trigger('click');
                        }
                    });
                });

                function initMenu() {
                    $('.megamenu').css('right', '');
                    $('ul.sub-menu-level-0').css('margin-left', '');
                    $('ul.sub-menu-level-1').css('left', '');
                    $('div.last-column').css('left', '');
                    $('.go-to-link').data('parent', {'label': '', 'url': ''});
                    if ($(window).width() >= breakpointXl) {
                        setListsWidth(gutterXl, 6, 2);
                        setPositions(gutterXl);
                        setListsHeight();
                    } else if ($(window).width() >= breakpointLg) {
                        setListsWidth(gutterLg, 4.5, 1.5);
                        setPositions(gutterLg);
                        setListsHeight();
                    } else if ($(window).width() >= breakpointMd) {
                        setListsWidth(gutterLg, 3, 0);
                        setPositions(gutterLg);
                        setListsHeight();
                    } else {
                        setListsWidth(20, 1, 0, isMobile);
                        setListsHeight();
                    }
                }

                $('.mobile-menu-toggle').click(function () {
                    $mobileOverlay.css('visibility', 'visible').animate({opacity: 0.8}, 600);
                    $('.close-mobile-menu, .utilities-container').css('visibility', 'visible').animate({opacity: 1}, 600);
                    $mainMenuContainer.addClass('open-menu');
                    $('body').addClass('main-menu-open');
                });

                $($header).find('.close-mobile-menu').click(function () {
                    $mobileOverlay.animate({opacity: 0}, 600).css('visibility', 'hidden');
                    $('.close-mobile-menu, .utilities-container').animate({opacity: 0}, 600).css('visibility', 'hidden');
                    $mainMenuContainer.removeClass('open-menu');
                    closeMegamenu(megamenuToggle, true);
                    $('body').removeClass('main-menu-open');
                    $('a.close-search').trigger('click');
                });

                $mobileOverlay.click(function () {
                    $($header).find('.close-mobile-menu').trigger('click');
                });

                $(window).resize(function () {
                    megamenuToggle.each(function () {
                        if ($(this).hasClass('active')) {
                            $(this).trigger('click');
                        }
                    });
                    isMobile = ($(window).width() < breakpointMd);
                    if ($mainMenuContainer.hasClass('open-menu')) {
                        $('.close-mobile-menu').trigger('click');
                        $('a.close-search').trigger('click');
                    }
                    initMenu();
                });

                $(document).scroll(function () {
                    if (megamenuToggle.is('.active')) {
                        closeMegamenu(megamenuToggle, true);
                    }
                });

                initMenu();

                // Search Form
                var searchToggle = $('.open-search-form'),
                    searchContainer = $('#search-form-container'),
                    closeSearchToggle = $('a.close-search');

                searchToggle.click(function (evt) {
                    evt.preventDefault();
                    if (!searchContainer.hasClass('open')) {
                        if (!isMobile) {
                            searchContainer.show().animate({top: 0}, 600);
                        } else {
                            searchContainer.show().animate({right: 0}, 600);
                        }
                        searchContainer.addClass('open');
                    }
                });

                closeSearchToggle.click(function (evt) {
                    evt.preventDefault();
                    if (searchContainer.hasClass('open')) {
                        if (!isMobile) {
                            searchContainer.animate({top: '-' + $header.outerHeight() + 'px'}, 600, 'swing', function () {
                                $(this).hide();
                            });
                        } else {
                            searchContainer.animate({right: '-65%'}, 600, 'swing', function () {
                                $(this).hide();
                            });
                        }
                        searchContainer.removeClass('open');
                    }
                });


                // Masonry listing decorations

                var masonryListingContainer = $('.listing-special-masonry, .media-container-masonry');

                function createDecorationSpan(masonry) {
                    masonry.find('.list-item-image-container').each(function () {
                        $('body').append('<span class="masonry-decoration" style="top:' + $(this).offset().top + 'px"></span>');
                    });

                }

                function initMasonryDecoration(masonry) {

                    if (masonry.is('.media-container-masonry')) {
                        masonry.isotope({
                            itemSelector: '.media-item',
                            stamp: '.media-press-stamp'
                        });
                    } else {
                        masonry.isotope({
                            itemSelector: '.list-item',
                            initLayout: false
                        });
                    }

                    masonry.on('layoutComplete', function () {
                        $('span.masonry-decoration').fadeOut(600).remove();
                        createDecorationSpan(masonry);
                        $('span.masonry-decoration').fadeIn(600);
                    });


                    masonry.isotope();


                    $(window).resize(function () {
                        $('span.masonry-decoration').fadeOut(600).remove();
                    });
                }

                if (masonryListingContainer.length > 0) {
                    masonryListingContainer.each(function (i, el) {
                        initMasonryDecoration($(el), i);
                    });
                }

                // Go-to-top

                var $goToTop = $('#go-to-top');

                if ($goToTop.length !== 0) {
                    $goToTop.click(function (evt) {
                        evt.preventDefault();
                        $('html, body').animate({
                            scrollTop: 0
                        }, 1000);
                    });
                }

                $(window).on('scroll', function () {
                    if ($(window).scrollTop() > ($(window).height() / 2) && $goToTop.css('opacity') === '0') {
                        $goToTop.animate({'opacity': 0.1}, 400);
                    } else if ($(window).scrollTop() < ($(window).height() / 2) && $goToTop.css('opacity') === '0.1') {
                        $goToTop.animate({'opacity': 0}, 400);
                    }
                });

                // Preloader control

                var width = 100,
                    perfData = window.performance.timing, // The PerformanceTiming interface represents timing-related performance information for the given page.
                    EstimatedTime = -(perfData.loadEventEnd - perfData.navigationStart),
                    time = parseInt((EstimatedTime / 1000) % 60) * 100;

                // Loadbar Animation
                $(".progress-loading").animate({
                    width: width + "%"
                }, time);

                // Percentage Increment Animation
                var Percentage = $(".percentage"),
                    start = 0,
                    end = 100,
                    durataion = time;

                function animateValue(id, start, end, duration) {

                    var range = end - start,
                        current = start,
                        increment = end > start ? 1 : -1,
                        stepTime = Math.abs(Math.floor(duration / range)),
                        obj = $(id);

                    var timer = setInterval(function () {
                        current += increment;
                        $(obj).text(current + "%");
                        if (current === end) {
                            clearInterval(timer);
                        }
                    }, stepTime);
                }

                animateValue(Percentage, start, end, durataion);

                // Fading Out Loadbar on Finised
                setTimeout(function () {
                    $('#preloader').fadeOut(600);
                }, time);


                var $modalToggle = $('#modal-toggle,.custom-slide'),
                    $modalClose = $('#modal-close'),
                    $body = $('body');
                window.galleryModal = $('#gallery-modal,[data-gallery-id]');


                function closeModal($modal) {
                    $modal.animate({'opacity': 0}, 400, function () {
                        $modal.css('visibility', 'hidden');
                    });
                    $('.wfl').css('background-color', '#000000');
                    //$body.css({'overflow': '', 'position': ''});
                    $modal.removeClass('gallery-modal-opened');
                }

                function openModal($modal) {
                    $modal.css('visibility', 'visible');
                    $modal.animate({'opacity': 1}, 400);
                    $('.wfl').css('background-color', '#ffffff');
                    //$body.css({'overflow': 'hidden', 'position': 'fixed'});
                    $modal.addClass('gallery-modal-opened');
                    var h = $('.gallery-modal-opened').find('.owl-item.active .slide-content').html();
                    if (h) {
                        $('.gallery-modal-opened .caption-container > span').html(h);
                    }
                }

                $('[data-target-gallery-id]').on('click', function (e) {
                    e.preventDefault();
                    var targetGalleryIdModal = $(this).data('target-gallery-id');
                    if (targetGalleryIdModal) {
                        var targetGalleryModal = $('[data-gallery-id="' + targetGalleryIdModal + '"]');
                        if (targetGalleryModal) {
                            openModal(targetGalleryModal);
                        }
                    }
                });

                if (window.galleryModal.length > 0) {
                    $modalToggle.on('click', function (evt) {
                        evt.preventDefault();
                        openModal(window.galleryModal);
                    });

                    $modalClose.on('click', function (evt) {
                        evt.preventDefault();
                        closeModal(window.galleryModal);
                    });


                    $(document).on('keyup', function (evt) {
                        if (evt.keyCode === 27) {
                            closeModal(window.galleryModal);
                        }
                    });

                    var owl = window.galleryModal
                        .find('.gallery')
                        .owlCarousel({
                            items: 1,
                            nav: true,
                            navText: ['<div class="nav-arrow"><i class="arrow-left-icon-negative"></i><span>PREV</span></div>', '<div class="nav-arrow"><i class="arrow-right-icon-negative"></i><span>NEXT</span></div>'],
                            center: true,
                            lazyLoad: true,
                            loop: true,
                            animateOut: 'fadeOut'
                        });

                    owl.on('changed.owl.carousel', function (event) {
                        setTimeout(function () {
                            var h = $('.gallery-modal-opened').find('.owl-item.active .slide-content').html();
                            if (h) {
                                $('.gallery-modal-opened .caption-container > span').html(h);
                            }
                        }, 500);
                    });
                }

            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired

                function add_marker($marker, map) {        // var
                    var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));        // create marker
                    var marker = new google.maps.Marker({
                        position: latlng,
                        map: map,
                        icon: {
                            path: 'm14.5,43.5c0,-16.0221 12.977901,-29 29,-29c16.0221,0 29,12.977901 29,29c0,16.0221 -12.977901,29 -29,29c-16.0221,0 -29,-12.977901 -29,-29z',
                            fillColor: 'black',
                            fillOpacity: 1,
                            strokeColor: 'white',
                            strokeWeight: 5,
                            scale: 0.5,
                            scaledSize: new google.maps.Size(30, 30),
                            anchor: new google.maps.Point(30, 30),
                        }
                    });
                    map.markers.push(marker);        // if marker contains HTML, add it to an infoWindow

                    if ($marker.html()) {
                        // create info window
                        var infowindow = new google.maps.InfoWindow({
                            content: $marker.html()
                        });            // show info window when marker is clicked
                        google.maps.event.addListener(marker, 'click', function () {
                            infowindow.open(map, marker);
                        });
                    } else {
                        google.maps.event.addListener(marker, 'click', function () {
                            if ($marker.attr('data-link')) {
                                window.open($marker.attr('data-link'), '_blank');
                            } else {
                                window.open('https://www.google.com/maps/place/' + $marker.attr('data-lat') + ',' + $marker.attr('data-lng'), '_blank');
                            }
                        });
                    }
                }

                function center_map(map) {        // vars
                    var bounds = new google.maps.LatLngBounds();        // loop through all markers and create bounds
                    $.each(map.markers, function (i, marker) {
                        var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
                        bounds.extend(latlng);
                    });        // only 1 marker?
                    if (map.markers.length === 1) {
                        // set center of map
                        map.setCenter(bounds.getCenter());
                        map.setZoom(16);
                    } else {
                        // fit to bounds
                        map.fitBounds(bounds);
                    }
                }

                function new_map($el) {        // var
                    var $markers = $el.find('.marker');
                    // vars
                    var args = {
                        zoom: 18,
                        center: new google.maps.LatLng(0, 0),
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        fullscreenControl: !1,
                        zoomControl: !0,
                        disableDoubleClickZoom: !0,
                        mapTypeControl: !1,
                        scaleControl: !1,
                        scrollwheel: !1,
                        streetViewControl: !1,
                        draggable: !0,
                        clickableIcons: !1,
                        styles: [
                            {
                                featureType: "water",
                                elementType: "geometry",
                                stylers: [
                                    {
                                        color: "#e9e9e9"
                                    },
                                    {
                                        lightness: 17
                                    }
                                ]
                            },
                            {
                                featureType: "landscape",
                                elementType: "geometry",
                                stylers: [
                                    {
                                        color: "#f5f5f5"
                                    },
                                    {
                                        lightness: 20
                                    }
                                ]
                            },
                            {
                                featureType: "road.highway",
                                elementType: "geometry.fill",
                                stylers: [
                                    {
                                        color: "#ffffff"
                                    },
                                    {
                                        lightness: 17
                                    }
                                ]
                            },
                            {
                                featureType: "road.highway",
                                elementType: "geometry.stroke",
                                stylers: [
                                    {
                                        color: "#ffffff"
                                    },
                                    {
                                        lightness: 29
                                    },
                                    {
                                        weight: 0.2,
                                    }
                                ]
                            },
                            {
                                featureType: "road.arterial",
                                elementType: "geometry",
                                stylers: [
                                    {
                                        color: "#ffffff"
                                    },
                                    {
                                        lightness: 18
                                    }
                                ]
                            },
                            {
                                featureType: "road.local",
                                elementType: "geometry",
                                stylers: [
                                    {
                                        color: "#ffffff"
                                    },
                                    {
                                        lightness: 16
                                    }
                                ]
                            },
                            {
                                featureType: "poi",
                                elementType: "geometry",
                                stylers: [
                                    {
                                        color: "#f5f5f5"
                                    },
                                    {
                                        lightness: 21
                                    }
                                ]
                            },
                            {
                                featureType: "poi.park",
                                elementType: "geometry",
                                stylers: [
                                    {
                                        color: "#dedede"
                                    },
                                    {
                                        lightness: 21
                                    }
                                ]
                            },
                            {
                                elementType: "labels.text.stroke",
                                stylers: [
                                    {
                                        visibility: "on"
                                    },
                                    {
                                        color: "#ffffff"
                                    },
                                    {
                                        lightness: 16
                                    }
                                ]
                            },
                            {
                                elementType: "labels.text.fill",
                                stylers: [
                                    {
                                        saturation: 36
                                    },
                                    {
                                        color: "#333333"
                                    },
                                    {
                                        lightness: 40
                                    }
                                ]
                            },
                            {
                                elementType: "labels.icon",
                                stylers: [
                                    {
                                        visibility: "off"
                                    }
                                ]
                            },
                            {
                                featureType: "transit",
                                elementType: "geometry",
                                stylers: [
                                    {
                                        color: "#f2f2f2"
                                    },
                                    {
                                        lightness: 19
                                    }
                                ]
                            },
                            {
                                featureType: "administrative",
                                elementType: "geometry.fill",
                                stylers: [
                                    {
                                        color: "#fefefe"
                                    },
                                    {
                                        lightness: 20
                                    }
                                ]
                            },
                            {
                                featureType: "administrative",
                                elementType: "geometry.stroke",
                                stylers: [
                                    {
                                        color: "#fefefe"
                                    },
                                    {
                                        lightness: 17
                                    },
                                    {
                                        weight: 1.2
                                    }
                                ]
                            }
                        ]
                    };
                    // create map
                    var map = new google.maps.Map($el[0], args);
                    // add a markers reference
                    map.markers = [];
                    // add markers
                    $markers.each(function () {
                        add_marker($(this), map);
                    });
                    // center map
                    center_map(map);
                    // return
                    return map;
                }

                var map = null;
                $('.acf-map').each(function () {            // create map
                    map = new_map($(this));
                });
            },
            onLoad: function () {

                function scrollTo(hash) {
                    var menu_height = $("header").outerHeight(true);
                    $('html, body').animate({
                        scrollTop: $('#' + hash).offset().top - menu_height
                    }, 500);
                }

                if (window.location.hash !== '' && window.location.hash.match(/^[a-zA-Z0-9_#-]*$/g) && $(window.location.hash).length > 0) {
                    var hash = window.location.hash.replace('#', '');
                    window.location.hash = '';
                    scrollTo(hash);
                }

                $('a[href*="#"]:not([href="#"])').each(function () {
                    var $this = $(this);
                    var uri = new URI($this.prop('href'));

                    if (uri.fragment().match(/^[a-zA-Z0-9_-]*$/g) && uri.path() === window.location.pathname && $('#' + uri.fragment()).length > 0) {
                        $this.click(function (evt) {
                            evt.preventDefault();
                            scrollTo(uri.fragment());
                        });
                    }
                });
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page

                // Common variables

                var $sliderCaptionTarget = $('.slider-caption-bg .background'),
                    headerHeight = $('header.top-bar').outerHeight(),
                    $sectionMain = $('#homepage-main'),
                    $videoContainer = $('#homepage-video-container'),
                    currentScroll = $(window).scrollTop(),
                    isMobile = $(window).width() <= 991;

                var $homepageVideo = $videoContainer.find('video');


                // Init Slider

                function populateCaption() {
                    var caption = $('<div>').append($('#homepage-slider .slide-item').eq(this._current).find('.caption-container').clone()).html();
                    $sliderCaptionTarget.find('.caption-container').fadeOut(500, function () {
                        $sliderCaptionTarget.html(caption).find('.caption-container').fadeIn(500);
                    });
                }

                $('#homepage-slider').owlCarousel({
                    loop: true,
                    nav: true,
                    autoplay: true,
                    autoplayTimeout: 7000,
                    items: 1,
                    dots: true,
                    dotsContainer: '#homepage-slider-dots',
                    navText: ['<div class="nav-arrow"><i class="arrow-left-icon-negative"></i><span>PREV</span></div>', '<div class="nav-arrow"><i class="arrow-right-icon-negative"></i><span>NEXT</span></div>'],
                    onInitialized: populateCaption,
                    onTranslate: populateCaption,
                    animateOut: 'fadeOut'
                });

                // Main Content & Video controls

                function checkVideoPosition() {

                    var videoContainerHeight = $videoContainer.outerHeight(true);
                    var sectionHeight = $sectionMain.outerHeight(true);
                    var sectionTop = $sectionMain.offset().top;
                    var sectionBottom = sectionTop + sectionHeight;

                    if ($(window).width() >= 992) {
                        if (currentScroll >= sectionTop) {
                            if (currentScroll >= sectionBottom - videoContainerHeight) {
                                $videoContainer.removeClass('video-affix');
                                if (!$homepageVideo[0].paused) {
                                    $homepageVideo[0].pause();
                                }
                                $videoContainer.css('top', sectionHeight - videoContainerHeight);
                            } else {
                                $videoContainer.addClass('video-affix');
                                $videoContainer.css('top', 0);
                                $homepageVideo.css('visibility', 'visible').animate({'opacity': 1}, 600);
                                if ($homepageVideo[0].paused) {
                                    $homepageVideo[0].play();
                                }
                            }
                        } else {
                            $videoContainer.removeClass('video-affix');
                            if (!$homepageVideo[0].paused) {
                                $homepageVideo[0].pause();
                            }
                        }
                    } else {
                        $videoContainer.removeClass('video-affix');
                        $videoContainer.css('top', 0);
                    }

                }

                $videoContainer.click(function () {
                    if ($homepageVideo.css('visibility') === 'hidden') {
                        $homepageVideo.css('visibility', 'visible').animate({'opacity': 1}, 600);
                    }
                    if ($homepageVideo[0].paused) {
                        $('.video-play-btn').animate({'opacity': 0}, 600);
                        $homepageVideo[0].play();
                    } else {
                        $homepageVideo[0].pause();
                        $('.video-play-btn').animate({'opacity': 1}, 600);
                    }
                });

                checkVideoPosition();


                //Update events

                $(window).on('resize', function () {
                    headerHeight = $('header.top-bar').outerHeight();
                    checkVideoPosition();
                    if (isMobile !== $(window).width() <= 991) {
                        isMobile = $(window).width() <= 991;
                    }
                    isMobile = $(window).width() <= 991;
                });

                $(window).on('scroll', function () {
                    currentScroll = $(window).scrollTop();
                    checkVideoPosition();
                });

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // Template Flexible
        'page_template_template_flexible': {
            init: function () {

                //script for opening modal on click on flexible template lists
                $('.list-item').on('click', '.open-modal-button', function (event) {
                    event.preventDefault();
                    var $this = $(this);
                    var parent_of_button = $this.parents(".list-item");
                    var modal_media_container = parent_of_button.find(".modal-media");
                    var modal_video_src = parent_of_button.find('.video-link').attr("data-media-video");
                    modal_media_container.modal('show');
                    modal_media_container.on('shown.bs.modal', function () {
                        if (modal_video_src) {
                            var video_modal = modal_media_container.find('.modal-body-video');
                            if (video_modal.length > 0) {
                                video_modal.html(modal_video_src);
                            }
                        }
                    });
                });

                var modal_media_video = $(".modal-media");
                modal_media_video.on('hidden.bs.modal', function () {
                    modal_media_video.find('.modal-body-video iframe').remove();
                });

            }
        },
        // Template 07 - Story
        'page_template_template_07': {
            init: function () {
                // JavaScript to be fired on the about us page

                var $timeline = $('.timeline-container'),
                    $technicalSliders = $('.technical-block .owl-carousel'),
                    $collectionSliders = $('.collection-items-container .owl-carousel');


                function initSliders() {

                    if ($technicalSliders.length > 0) {
                        $technicalSliders.each(function () {
                            $(this).owlCarousel({
                                loop: true,
                                nav: false,
                                dots: true,
                                items: 1,
                                margin: 30
                                // autoplay: true,
                                // autoplayTimeout: 5000,
                                // autoplayHoverPause:true,
                                // animateOut: 'fadeOut'
                            });
                        });
                    }

                    if ($collectionSliders.length > 0) {
                        $collectionSliders.each(function () {
                            var slider = $(this);
                            var items = slider.find('.collection-item').length;

                            slider.owlCarousel({
                                nav: false,
                                dots: false,
                                navText: ['<i class="arrow-left-icon-black-small"></i>', '<i class="arrow-right-icon-black-small"></i>'],
                                responsive: {
                                    0: {
                                        loop: true,
                                        mouseDrag: true,
                                        touchDrag: true,
                                        nav: true,
                                        items: 1
                                    },
                                    992: {
                                        loop: false,
                                        mouseDrag: false,
                                        touchDrag: false,
                                        nav: false,
                                        items: items
                                    }
                                }
                            });
                        });
                    }

                }

                $timeline.imagesLoaded(function () {
                    initSliders();
                });
            }
        },

        // Page Template 06 - Numeri
        'page_template_template_06': {
            init: function () {

                $('#page_slider').owlCarousel({
                    loop: true,
                    nav: true,
                    navText: ['<div class="nav-arrow"><i class="arrow-left-icon"></i><span>PREV</span></div>', '<div class="nav-arrow"><i class="arrow-right-icon"></i><span>NEXT</span></div>'],
                    dots: true,
                    items: 1,
                    margin: 30,
                    autoplay: true,
                    autoplayTimeout: 5000,
                    autoplayHoverPause: true,
                    animateOut: 'fadeOut'
                });

                function setSlideBg() {

                    $('#page_slider').find('.slide-container').each(function () {
                        var $this = $(this);
                        if ($(window).width() > 991) {
                            $this.css('background-image', 'url("' + $this.data('bg-desktop') + '")');
                        } else {
                            $this.css('background-image', 'url("' + $this.data('bg-mobile') + '")');
                        }
                    });

                }

                setSlideBg();

                $(window).on('resize', function () {
                    setSlideBg();
                });

            }

        },
        'media_post_template_default': {
            init: function () {
                // moved into common
            }
        },
        'page_template_template_dys': {
            init: function () {

                var $parallaxSliders = $('.parallax-carousel');

                function initParallaxSlider($slider) {
                    $slider.owlCarousel({
                        loop: true,
                        nav: true,
                        dots: false,
                        navText: ['<i class="arrow-left-icon-black-small"></i>', '<i class="arrow-right-icon-black-small"></i>'],
                        mouseDrag: true,
                        touchDrag: true,
                        items: 1
                    });
                }

                if ($parallaxSliders.length > 0) {

                    if (window.innerWidth < 992) {
                        $parallaxSliders.each(function (i, slider) {
                            initParallaxSlider($(slider));
                        });
                    }
                    $(window).on('resize', function () {
                        if (window.innerWidth >= 992) {
                            $parallaxSliders.each(function (i, slider) {
                                if ($(slider).data('owl.carousel') !== undefined) {
                                    $(slider).data('owl.carousel').destroy();
                                }
                            });
                        } else {
                            $parallaxSliders.each(function (i, slider) {
                                if ($(slider).data('owl.carousel') === undefined) {
                                    initParallaxSlider($(slider));
                                }
                            });
                        }
                    });
                }

                // Inspiration Gallery

                var $innovationGallery = $('#innovation-gallery');
                var $effectContainer = $('.effect-container');

                function updateCounter(currentSlide) {
                    var $galleryCounter = $('.gallery-counter');
                    $galleryCounter.find('.actual').text($innovationGallery.find('.owl-item').eq(currentSlide).find('.slide-elements').data('index'));
                }

                function updateSlideElements(slideIndex) {
                    var $slide = $innovationGallery.find('.owl-item').eq(slideIndex);
                    $effectContainer.find('.effect-base img').attr('src', $slide.find('.slide-elements .base-img').attr('src'));
                    $effectContainer.find('.effect-texture img').attr('src', $slide.find('.slide-elements .texture-img').attr('src'));
                    $effectContainer.find('.effect-name span').text($slide.find('.slide-elements span').text());
                }

                $innovationGallery.on('initialized.owl.carousel', function (event) {
                    updateSlideElements(event.item.index);
                    updateCounter(event.item.index, event.item.count);
                });

                $innovationGallery.on('translate.owl.carousel', function (event) {
                    $effectContainer.removeClass('fade-in');
                    $effectContainer.addClass('fade-out');
                    updateCounter(event.item.index, event.item.count);
                });

                $innovationGallery.on('translated.owl.carousel', function (event) {
                    $effectContainer.removeClass('fade-out');
                    $effectContainer.addClass('fade-in');
                    updateSlideElements(event.item.index);
                });
                var innovationGallerySetup = {
                    loop: true,
                    nav: true,
                    smartSpeed: 400,
                    dots: false,
                    navText: ['<i class="arrow-left-icon-black-small"></i>', '<i class="arrow-right-icon-black-small"></i>'],
                    mouseDrag: true,
                    touchDrag: true,
                    items: 1
                };
                $innovationGallery.owlCarousel(innovationGallerySetup);
                $('.as-innovation-gallery').owlCarousel(innovationGallerySetup);

            }
        },
        'page_template_template_london': {
            init: function () {
                var customGallery = $('.custom-gallery');
                var fakeLoadMoreButton = $('#fake-load-more-news');

                function fixSpanCustomGalleryCounter() {
                    if ($('.owl-item.center').length) {
                        $('.custom-gallery-counter').css('paddingLeft', $('.owl-item.center').offset().left);
                    }
                }

                function fixFSConsiderHeader() {
                    $('.fullscreen-consider-header').height($(window).height() - $('header').outerHeight());
                }

                function loadMoreNewsFakeTill(n) {
                    $('#media-container-masonry').isotope({
                        filter: function () {
                            return $(this).index() < parseInt(n);
                        }
                    });
                }

                fixFSConsiderHeader();
                $('#hero-video-modal').on('shown.bs.modal', function () {
                    var iframe = $(this).find('iframe');
                    if (iframe) {
                        if (!iframe.attr('allow').includes('autoplay')) {
                            iframe.attr('allow', iframe.attr('allow') + '; autoplay');

                        }
                        iframe.attr('src', iframe.attr('src') + '?autoplay=true');
                    }
                }).on('hidden.bs.modal', function () {
                    var iframe = $(this).find('iframe');
                    if (iframe) {
                        iframe.attr('src', iframe.attr('src').replace('?autoplay=true', ''));
                    }
                });
                setTimeout(function () {
                    $(window).trigger('uiRefresh');
                }, 3000);
                $(window).on('load resize uiRefresh', function () {
                    fixFSConsiderHeader();
                    var customContainer = $('.custom-container');
                    var wAsContainer = (customContainer.outerWidth() - customContainer.width()) / 2;
                    $('.custom-gallery .owl-prev,.custom-gallery .owl-next').width(wAsContainer).height(wAsContainer);
                    fixSpanCustomGalleryCounter();
                    if (customGallery.data('owl.carousel')) {
                        customGallery.data('owl.carousel').options.responsive[600] = {
                            stagePadding: $(window).width() / 4
                        };
                        customGallery.data('owl.carousel').refresh();
                    }
                    if (parseInt($('.cover-contact-mobile-bg-col').outerWidth()) !== $(this).width()) {
                        $('.bg-contact-image').height($('#custom-map-contact').outerHeight());
                        $('.map-contact-buttons-absoluted').css('top', $('#custom-map-contact').outerHeight());
                    } else {
                        $('.bg-contact-image').height($('.cover-contact-mobile-bg-col').outerHeight());
                        $('.map-contact-buttons-absoluted').css('top', $('.cover-contact-mobile-bg-col').outerHeight());
                    }
                });

                $('[data-show-and-destroy],[data-hide-and-destroy]').on('click', function (e) {
                    e.preventDefault();
                    var target = null;
                    var action = 'show';
                    if (typeof $(this).data('show-and-destroy') !== "undefined") {
                        action = 'show';
                        target = $($(this).data('show-and-destroy'));
                    } else if (typeof $(this).data('hide-and-destroy') !== "undefined") {
                        action = 'hide';
                        target = $($(this).data('hide-and-destroy'));
                    }
                    $('[data-show-and-destroy="' + $(this).data('hide-and-destroy') + '"]').show(0);
                    if (target) {
                        if (action === 'hide') {
                            target.hide(0);
                        } else {
                            target.show(0);
                        }
                    }

                    $('.soft-destroy[data-show-and-destroy="' + $(this).data('show-and-destroy') + '"]').hide();
                    if ($(this).hasClass('soft-destroy')) {
                        $(this).hide();
                    } else {
                        if (!$(this).hasClass('no-destroy')) {
                            $(this).detach();
                        }
                    }
                });

                var customGalleryCounter = $('.custom-gallery-counter');
                customGallery.on('initialized.owl.carousel translated.owl.carousel', function (e) {
                    if (!e.namespace) {
                        return;
                    }
                    var carousel = e.relatedTarget;
                    customGalleryCounter.find('.current').text(carousel.relative(carousel.current()) + 1);
                    customGalleryCounter.find('.total').text(carousel.items().length);
                    window.galleryModal.find('.gallery').data('owl.carousel').to(carousel.relative(carousel.current()), 0);
                    fixSpanCustomGalleryCounter();
                });
                customGallery.owlCarousel({
                    loop: true,
                    nav: true,
                    dots: false,
                    items: 1,
                    margin: 45,
                    center: true,
                    stagePadding: 0,
                    navText: ['<i class="arrow-left-icon-black-small"></i>', '<i class="arrow-right-icon-black-small"></i>'],
                    responsive: {
                        0: {
                            items: 1,
                            stagePadding: 0
                        },
                        600: {
                            items: 1,
                            stagePadding: $(window).width() / 4
                        },
                    }
                });
                fakeLoadMoreButton.click(function (e) {
                    e.preventDefault();
                    var till = $(this).data('till');
                    loadMoreNewsFakeTill(till);
                    $(this).data('till', till + 2);
                    if (till >= $('#media-container-masonry').find('.media-item').length) {
                        $(this).detach();
                    }
                });
                if ($('#media-container-masonry').find('.media-item').length <= 2) {
                    $('#fake-load-more-news').detach();
                }
                loadMoreNewsFakeTill(2);
            }
        }
    };

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
                UTIL.fire(classnm, 'onLoad');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
            UTIL.fire('common', 'onLoad');
        },
        loadLateEvents: function () {

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm, 'onLoad');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'onLoad');
        }
    };

// Load Events
    $(document).ready(UTIL.loadEvents);
    $(window).on('load', UTIL.loadLateEvents);

})(jQuery); // Fully reference jQuery after this point.
